import React from 'react';
import useStyles from "../style";
import {renderErrorCreatePool} from "../../../utils/validate";
import ImageUploader from './ImageUploader';

function PoolMarketMakerIcon(props: any) {
  const classes = useStyles();
  const {
    register, errors,
    poolDetail, setValue
  } = props;
  const renderError = renderErrorCreatePool;

  const handleFileSelect = (imageUrl: any) => {
    setValue("market_maker_icon", imageUrl); // Assuming you're using something like useForm from react-hook-form
  };

  return (
    <>
      <div className={classes.formControl}>
        <label className={classes.formControlLabel}>Market Maker Icon</label>
        <input
          type="text"
          name="market_maker_icon"
          defaultValue={poolDetail?.market_maker_icon}
          ref={register({})}
          className={classes.formControlInput}
        />

        <p className={classes.formErrorMessage}>
          {renderError(errors, "market_maker_icon")}
        </p>
        <ImageUploader
          onFileSelect={handleFileSelect}
          width="50%"
          poolId={poolDetail?.id}
          value={poolDetail?.market_maker_icon}
        />
      </div>
    </>
  );
}

export default PoolMarketMakerIcon;
